module.exports = "/dist/assets/images/play-icon.svg";